var _defs, _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeashell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "288.75pt",
    height: "248.25pt",
    viewBox: "0 0 288.75 248.25",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient1",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop2",
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop3",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop4",
    offset: "100%"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .stop1 {\n      stop-color: #cbdfff;\n    }\n\n    .stop2 {\n      stop-color: #FFFFFF;\n    }\n\n    .stop3 {\n      stop-color: #FFFFFF;\n    }\n\n    .stop4 {\n      stop-color: #FFF8E4;\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    },
    transform: "translate(0,248.25)scale(.075,.075)",
    fill: "url(#Gradient1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M 1815 -3296 c -188 32 -340 179 -406 393 -22 72 -22 72 -65 43 -312 -215 -672 22 -662 434 3 122 3 122 -47 108 -408 -111 -677 359 -449 785 44 82 44 82 9 98 -386 184 -186 653 406 955 65 33 119 62 119 63 0 2 -9 20 -20 42 -138 270 106 380 823 372 216 -3 399 -5 407 -5 8 0 184 2 390 5 732 10 964 -91 840 -366 -11 -24 -20 -45 -20 -46 0 -2 60 -35 134 -74 283 -147 465 -299 537 -446 84 -173 15 -415 -142 -496 -38 -19 -38 -19 11 -116 221 -448 -33 -859 -475 -768 -30 7 -30 7 -27 -102 13 -410 -336 -654 -648 -452 -59 38 -59 38 -65 7 -68 -309 -335 -488 -650 -434 z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeashell);
export default __webpack_public_path__ + "static/media/seashell.600c5efae5e555a636f4cbea2da4eb1f.svg";
export { ForwardRef as ReactComponent };